import { render } from "./UserReplacement.vue?vue&type=template&id=40e29f6d&scoped=true"
import script from "./UserReplacement.vue?vue&type=script&lang=js"
export * from "./UserReplacement.vue?vue&type=script&lang=js"

import "./UserReplacement.vue?vue&type=style&index=0&id=40e29f6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e29f6d"]])

export default __exports__